module.exports = __webpack_public_path__ + "img/EmergingLeaders.54d58019.jpg";